// eslint-disable-next-line import/prefer-default-export
export const successMessages = {
	scheduled: 'A reboot has been successfully scheduled.',
	requested: 'A reboot request has been submitted.',
	rebooted: 'A reboot has been initiated.',
};
